import { useEffect } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";
import { useDispatch } from "react-redux";

import { TOGGLE_OFF_COMPARE_DROPDOWN, TOGGLE_ON_COMPARE_DROPDOWN } from "app/action_types/website_analysis_action-types";
import { keywordGroupsTransforms } from "app/services/keyword-groups";

export const useToggleQueryBarForKeywordGroups = () => {
    const { params } = useCurrentStateAndParams();
    const dispatch = useDispatch();

    useEffect(() => {
        const isKeywordGroup = keywordGroupsTransforms.isKeywordGroup(params.keyword);
        if (isKeywordGroup) {
            // We need to wait for the component to render before we can toggle the dropdown
            setTimeout(() => {
                dispatch({ type: TOGGLE_ON_COMPARE_DROPDOWN });
            });
        }
        return () => {
            dispatch({ type: TOGGLE_OFF_COMPARE_DROPDOWN });
        };
    }, []);
};
